import { render, staticRenderFns } from "./WwsFatherIcardPrint.vue?vue&type=template&id=ffda7a66&scoped=true&"
import script from "./WwsFatherIcardPrint.vue?vue&type=script&lang=js&"
export * from "./WwsFatherIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./WwsFatherIcardPrint.vue?vue&type=style&index=0&id=ffda7a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffda7a66",
  null
  
)

export default component.exports